// extracted by mini-css-extract-plugin
module.exports = {"footnote":"RRPFootnote_footnote__8zawr","text":"RRPFootnote_text__co0vj","link":"RRPFootnote_link__pmsxW"};